import { StyleSheet } from 'react-native';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';

export const useDesktopDropdownStyles = () =>
  useThemedStyles(({ components }) => {
    const admin = components.admin;
    return StyleSheet.create({
      menuItem: {
        paddingVertical: 12,
        paddingHorizontal: 16,
        borderBottomWidth: 1,
        borderBottomColor: admin.selector.border,
        backgroundColor: admin.selector.dropdownBg,
        flexDirection: 'row',
        alignItems: 'center',
      },
      iconWrap: {
        width: 24,
        alignItems: 'center',
        marginRight: 12,
      },
      menuText: {
        fontSize: 14,
        color: admin.dataCell.textMuted,
      },
    });
  });
